import { Box, Typography } from "@mui/material";
import {
  HeaderWrapper,
  logoContainer,
  practiceNameTypography,
  underline,
} from "./MainFastrHeaderStyles";
import { useGetPracticesInfoQuery } from "@services/landingPage";
import { localStorageService } from "@utils/storageService/StorageService";

export const MainFastrHeader = () => {
  const practiceId = localStorageService.get("fastr_practiceId")!;

  const { data: practiceInfo } = useGetPracticesInfoQuery(practiceId, {
    skip: !practiceId,
  });

  const practiceName = practiceInfo?.name || "";
  const logoBase64 = practiceInfo?.logo || "";

  return (
    <>
      <Box sx={HeaderWrapper}>
        <Box sx={logoContainer}>
          {logoBase64 ? (
            <img
              src={`data:image/png;base64,${logoBase64}`}
              alt="Practice Logo"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          ) : null}
        </Box>

        <Typography sx={practiceNameTypography}>{practiceName}</Typography>
      </Box>
      <Box sx={underline} />
    </>
  );
};
